module.exports = "/images/Collect customer data.svg?e66e9822a1c978a1b5d1bc92a56ccfb4";